import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'bcos-event';

export default {
    path: '/bcos/event',
    name: '订阅事件',
    redirect: {
        name: `${pre}blockEvent`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'blockEvent',
            name: `${pre}blockEvent`,
            meta: {
                ...meta,
                title: '出块事件',
                closable: true
            },
            component: () => import('@/bcos/views/event/block-event.vue')
        },
        {
            path: 'contractEvent',
            name: `${pre}contractEvent`,
            meta: {
                ...meta,
                title: '合约事件',
                closable: true
            },
            component: () => import('@/bcos/views/event/contract-event.vue')
        },
    ]
};
